import MapWrapper from "components/MapWrapper/MapWrapper";
import LotsMapMarker from 'features/maps/markers/LotsMapMarker/LotsMapMarker';
import { useTitle } from "hooks/useTitle";

const LotsMap = ({ lots, handleSelectLot, isNarrowScreen }) => {

    useTitle('Lots Map');

    const defaultProps = {
        center: {
            lat: 39.148171,
            lng: -101.763726
        },
        zoom: 4
    };

    let markers = lots?.map(lot => {
        return {
            ...lot,
            address: lot.addressLine1 + ', ' + lot.city + ', ' + lot.state,
            icon: <LotsMapMarker
                lot={lot}
                color={lot.ownedByTenant ? "#0090FE" : "#E48900"}
                text={lot.name}
            />,
            onClick: handleSelectLot,
            id: lot?.id
        }
    })

    return (
        <MapWrapper
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
            markers={markers}
            includeSearch
            isNarrowScreen={isNarrowScreen}
        />
    )
}

export default LotsMap;